import styled from 'styled-components'

import { theme } from '../../constants'

export const PersonCardContainer = styled.button`
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: ${theme.spacing[3]};
  padding: ${theme.spacing[3]};
  color: inherit;
  background: ${theme.semanticColors.background.elevated};
  border: 1px solid ${theme.semanticColors.border.default};
  border-radius: ${theme.radii.large};
  box-shadow: ${theme.shadows.small};
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition:
    transform ${theme.motion.normal} ${theme.motion.easing},
    box-shadow ${theme.motion.normal} ${theme.motion.easing};

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.medium};
  }

  &:focus-visible {
    outline: 3px solid ${theme.roleColors.student.focus};
    outline-offset: 3px;
  }
`

export const PersonAvatar = styled.div`
  position: relative;
  width: 72px;
  height: 72px;
  flex: 0 0 auto;
  overflow: visible;
  background: ${theme.roleColors.student.soft};
  border: 3px solid ${theme.roleColors.student.soft};
  border-radius: ${theme.radii.large};

  &::after {
    content: '';
    position: absolute;
    right: -5px;
    bottom: -4px;
    width: 20px;
    height: 8px;
    background: ${theme.roleColors.student.main};
    transform: rotate(-12deg);
    pointer-events: none;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: inherit;
  }
`

export const PersonContent = styled.div`
  min-width: 0;
  display: flex;
  flex: 1;
  text-align: left;
  flex-direction: column;
  gap: ${theme.spacing[1]};
  padding-top: ${theme.spacing[1]};

  strong {
    color: ${theme.semanticColors.text.primary};
    font-size: ${theme.typography.size.bodySmall};
    text-transform: capitalize;
  }

  span {
    display: flex;
    align-items: center;
    gap: ${theme.spacing[1]};
    color: ${theme.semanticColors.text.muted};
    font-size: ${theme.typography.size.caption};
  }

  svg {
    width: 14px;
    height: 14px;
    flex: 0 0 14px;
    color: ${theme.roleColors.student.main};
  }

  .person-tags {
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.spacing[1]};
    margin-top: ${theme.spacing[1]};
  }

  .person-tags small {
    padding: 4px 7px;
    color: ${theme.colors.black};
    background: ${theme.roleColors.student.soft};
    border-radius: ${theme.radii.pill};
    font-size: ${theme.typography.size.caption};
    line-height: ${theme.typography.lineHeight.compact};
  }
`

export const PersonAction = styled.span`
  width: 48px;
  height: 48px;
  display: grid;
  flex: 0 0 auto;
  margin-left: auto;
  place-items: center;
  color: ${theme.colors.black};
  background: ${theme.roleColors.student.main};
  border: 0;
  border-radius: ${theme.radii.medium};
  pointer-events: none;

  &:hover {
    background: ${theme.roleColors.student.main};
  }

  &:focus-visible {
    outline: 3px solid ${theme.roleColors.student.focus};
    outline-offset: 2px;
  }
`
